import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { formatDate } from './formatDate';

const ExportToExcelCustomButton = ({ data, fileName, columns, columnNames,buttonTitle }) => {
  
    const handleExport = () => {
        // Map the data to only include selected columns and rename headers
        const filteredData = data.map(row => {
          const newRow = {};
          columns.forEach((col, index) => {
            // Format date columns based on column names
            if (col === 'date' || col.toLowerCase().includes('date')) {
              const rawDate = row[col]; // Get the raw date value
              newRow[columnNames[index]] = rawDate ? formatDate(rawDate) : ""; // Check for null or undefined
            } else {
              newRow[columnNames[index]] = row[col];
            }
          });
          return newRow;
        });

    // Create a new workbook and add a worksheet with the processed data
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate binary data and create a Blob
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });

    // Use file-saver to prompt the save file dialog
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <button onClick={handleExport}>{buttonTitle}</button>
  );
};

export default ExportToExcelCustomButton;
